import React, { useRef } from "react";
import styles from "./style.module.css";
import { images } from "../../../../assets/images";
import { data } from "./data";
const Testmonials = () => {
  const { Left, Right } = images;

  let scrollcard = 0;
  const containerRef = useRef();
  
  const handlescrollLeft = () => {
    if (window.innerWidth < 476) {
      containerRef.current.scrollLeft -= 300;
    } else {
      containerRef.current.scrollLeft -= 500;
    }
  };

  const handlescrollRight = () => {
    if (window.innerWidth < 476) {
      containerRef.current.scrollLeft += 300;
    } else {
      containerRef.current.scrollLeft += 500;
    }
  };
  return (
    <div className={styles.container}>
      <h1>What the community members say</h1>
      <div className={styles.innerContainer}>
        <div className={styles.leftFade}></div>
        <div className={styles.rightFade}></div>
        <div
          className={styles.displayContainer}
          style={{ scrollLeft: scrollcard }}
          ref={containerRef}
        >
          {data.map((data) => (
            <div className={styles.cardContainer}>
              <img src={data.image} alt="User" className={styles.img} />

              <p className={styles.review}>"{data.review}"</p>
              <h3>{data.name}</h3>
              <p className={styles.company}>
                {data.position} @ {data.company}
              </p>
            </div>
          ))}
        </div>

        <div className={styles.buttonContainer}>
          <button
            className={styles.btnLeft}
            onClick={(e) => handlescrollLeft(e)}
          >
            {" "}
            <img src={Left} alt="Left" />
          </button>
          <button
            className={styles.btnRight}
            onClick={(e) => handlescrollRight(e)}
          >
            <img src={Right} alt="Right" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testmonials;
